/** @jsxImportSource @emotion/react */

import { EmptyDataStyle } from "./style.index";

const EmptyData = () => {
  return (
    <table css={EmptyDataStyle.wrapper}>
      <tbody>
        <tr css={EmptyDataStyle.item}>
          <th>Loại game</th>
          <td>0</td>
        </tr>
        <tr css={EmptyDataStyle.item}>
          <th>Tên trò chơi</th>
          <td>0</td>
        </tr>
        <tr css={EmptyDataStyle.item}>
          <th>Thời gian thanh toán</th>
          <td>DD/MM/YYYY</td>
        </tr>

        <tr css={EmptyDataStyle.item}>
          <th>Cược</th>
          <td>0</td>
        </tr>

        <tr css={EmptyDataStyle.item}>
          <th>Thanh toán</th>
          <td>0</td>
        </tr>
      </tbody>
    </table>
  );
};

export default EmptyData;
